import { render, staticRenderFns } from "./GeneralPolyAssestment.vue?vue&type=template&id=7f85c84c&scoped=true"
import script from "./GeneralPolyAssestment.vue?vue&type=script&lang=js"
export * from "./GeneralPolyAssestment.vue?vue&type=script&lang=js"
import style0 from "./GeneralPolyAssestment.vue?vue&type=style&index=0&id=7f85c84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f85c84c",
  null
  
)

export default component.exports